import { render } from "./AposSubmittedDraftIcon.vue?vue&type=template&id=596542a8&scoped=true"
import script from "./AposSubmittedDraftIcon.vue?vue&type=script&lang=js"
export * from "./AposSubmittedDraftIcon.vue?vue&type=script&lang=js"

import "./AposSubmittedDraftIcon.vue?vue&type=style&index=0&id=596542a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596542a8"],['__file',"submitted-draft/ui/apos/components/AposSubmittedDraftIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "596542a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('596542a8', __exports__)) {
    api.reload('596542a8', __exports__)
  }
  
  module.hot.accept("./AposSubmittedDraftIcon.vue?vue&type=template&id=596542a8&scoped=true", () => {
    api.rerender('596542a8', render)
  })

}


export default __exports__